import { GradeTag } from './GradeTag';

import { VALUE_FONT } from '@/theme/consts';


export interface ScoreLockupProps {
  score: number;
  grade: string;
  /** the figure's ink; defaults to the theme's text */
  color?: string;
  compact?: boolean;
}

// A score card's hero: the light figure with its grade beside it, the grade a square tag over a quiet "/100", all
// sitting on the figure's baseline as one unit
export const ScoreLockup = ({ score, grade, color = 'var(--tx-text)', compact = false }: ScoreLockupProps) => (
  <div data-testid="score-lockup" style={{ display: 'inline-flex', alignItems: 'flex-end', gap: compact ? 8 : 10 }}>
    <div
      style={{
        fontFamily: VALUE_FONT,
        fontSize: compact ? 52 : 64,
        // hairline: a step thinner than Tradehaus's 300 titles, the digits set close (proportional figures: a lone hero
        // number has no column to align with, and tabular slots leave a gap around narrow digits like 1)
        fontWeight: 200,
        letterSpacing: '-0.07em',
        lineHeight: 0.8,
        fontVariantNumeric: 'proportional-nums',
        color,
      }}>
      {Math.round(score)}
    </div>
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 6 }}>
      <GradeTag grade={grade} size={compact ? 'sm' : 'md'} neutral />
      <span style={{ fontSize: 11, fontWeight: 500, lineHeight: 1, color: 'var(--tx-muted)' }}>/100</span>
    </div>
  </div>
);

export default ScoreLockup;
